<template>
  <el-config-provider :locale="locale">
    <Navbar v-if="!$route.meta.showNav" />
    <div class="main" v-if="!$route.meta.showNav"></div>
    <router-view></router-view>
  </el-config-provider>
</template>

<script>
import Navbar from "./views/components/NavBar.vue";
import { ElConfigProvider } from "element-plus";
// 引入中文包
import zhCn from "element-plus/es/locale/lang/zh-cn";
const debounce = (fn, delay) => {
  let timer;
  return (...args) => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn(...args);
    }, delay);
  };
};

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 200);
    super(callback);
  }
};
export default {
  name: "App",
  components: {
    Navbar,
    [ElConfigProvider.name]: ElConfigProvider,
  },
  setup() {
    const lang = () => {
      // eslint-disable-line no-unused-vars(如果运行时报错，就加上前面这行注释)
      location.reload();
    };
    let locale = zhCn;
    return {
      locale,
    };
  },
  provide() {
    return {
      pageReload: this.pageReload,
    };
  },
  data() {
    return {
      navBarHiddenPages: ["/", "/404"],
      isNavBarPage: false,
      isReload: true,
    };
  },
  mounted() {
    if (this.navBarHiddenPages.indexOf(this.$route.path) == -1) {
      this.isNavBarPage = false;
    } else {
      this.isNavBarPage = true;
    }
  },
  methods: {
    pageReload() {
      this.$nextTick(function () {
        setTimeout(() => {
          this.$router.push({ path: "/index" });
        }, 0);
      });
    },

    // reload() {
    //   this.isReload = false;
    //   this.$nextTick(() => {
    //     this.isReload = true;
    //   });
    // },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #f2f4f5;
}
.main {
  margin-top: 60px;
}
</style>
